import { Select } from "@chakra-ui/react";
import React, { useState } from "react";

interface SelectBoxProps {
  options: { value: string; label: string }[];
  filterKey: string;
  updateFilter: (filterKey: string, value: any) => void;
  defaultValue?: any;
  placeholder?: string;
}

function SelectBox({
  options,
  filterKey,
  updateFilter,
  defaultValue,
  placeholder = "Select an option",
}: SelectBoxProps) {
  const [value, setValue] = useState(defaultValue ?? "");

  return (
    <Select
      value={value}
      defaultValue={defaultValue}
      onChange={(e) => {
        updateFilter(filterKey, e.target.value);
        setValue(e.target.value);
      }}
    >
      <option value="">{placeholder}</option>
      {options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
}

export default SelectBox;
